import isEmpty from 'lodash/isEmpty';
import * as types from '../actionTypes/MyListActionTypes';

function MyListReducer(state = { listItems: {} }, action = {}) {
    // NOSONAR
    switch (action.type) {
        case types.DELETE_LIST:
        case types.SAVE_TO_LIST:
        case types.CREATE_LIST: {
            const isLoading = true;
            const requestFrom = null;
            return { ...state, isLoading, requestFrom, createListError: null };
        }
        case types.GET_LIST: {
            const isLoading = true;
            return { ...state, isLoading };
        }
        case types.GET_TRENDING_LIST: {
            const isTrendingLoading = true;
            return { ...state, isTrendingLoading };
        }

        case types.GET_LIST_SUCCESS: {
            const { response: listItems, isLoading, requestFrom } = action.payload || {};
            return { ...state, listItems, isLoading, requestFrom, error: null };
        }
        case types.GET_TRENDING_LIST_SUCCESS: {
            const trendingListItems = action.payload.response;
            const { isTrendingLoading } = action.payload;
            const { isSuccess } = action.payload;
            return { ...state, trendingListItems, isTrendingLoading, isSuccess };
        }
        case types.LOAD_TRENDING_ITEMS: {
            const { isSort } = action.payload;
            let trendingItem = {};
            if (isSort) {
                trendingItem = state.trendingItem;
            }
            const newTrendingItem = {
                ...trendingItem,
                isTrendingListItemsLoading: true,
            };
            return {
                ...state,
                trendingItem: newTrendingItem,
            };
        }
        case types.LOAD_TRENDING_ITEMS_SUCCESS: {
            const { response, queryParams, isLoaded } = action.payload;
            const trendingItem = {
                data: response.data,
                queryParams,
                statusCode: response.status,
                isLoaded,
            };
            return {
                ...state,
                trendingItem,
            };
        }
        case types.LOAD_TRENDING_ITEMS_ERROR: {
            const { error, response, queryParams } = action.payload;
            const trendingItem = {
                data: {},
                error,
                queryParams,
                statusCode: response.status,
            };
            return {
                ...state,
                trendingItem,
            };
        }
        case types.CREATE_LIST_SUCCESS: {
            const newState = { ...state, createListError: null };
            newState.listItems = { ...state.listItems };
            newState.isLoading = action.payload.isLoading;
            newState.isSuccess = action.payload.isSuccess;
            newState.requestFrom = action.payload.requestFrom;
            newState.createdItem = action.payload.response;
            return newState;
        }
        case types.DELETE_LIST_SUCCESS: {
            const newState = { ...state };
            newState.listItems = { ...state.listItems };
            newState.isLoading = action.payload.isLoading;
            newState.isSuccess = action.payload.isSuccess;
            newState.requestFrom = action.payload.requestFrom;
            newState.listItems.listData = newState.listItems.listData.filter(
                (list) => list.id !== action.payload.deleteId
            );
            newState.listItems.totalList -= 1;
            return newState;
        }
        case types.SAVE_TO_LIST_SUCCESS: {
            const newState = { ...state };
            newState.listItems = { ...state.listItems };
            newState.isLoading = action.payload.isLoading ? action.payload.isLoading : false;
            newState.isSuccess = action.payload.isSuccess ? action.payload.isSuccess : false;
            newState.error = action.payload.error ? action.payload.error : {};
            newState.requestFrom = action.payload.requestFrom;
            if (action.payload.isSuccess) {
                for (let i = 0; i < newState.listItems.listData.length; i += 1) {
                    if (newState.listItems.listData[i].id === action.payload.listId) {
                        newState.listItems.listData[i].name = action.payload.list.name;
                        newState.listItems.listData[i].eventDate = action.payload.list.eventDate;
                        newState.listItems.listData[i].isPublic = action.payload.list.isPublic;
                    }
                }
            }
            return newState;
        }
        case types.GET_TRENDING_LIST_ERROR: {
            const error = action.payload.response;
            const { isTrendingLoading } = action.payload;
            const { isSuccess } = action.payload;
            return { ...state, isTrendingLoading, error, isSuccess };
        }

        case types.CREATE_LIST_ERROR: {
            const payload = action.payload || {};
            /* Short Circuit if payload is not available */
            if (isEmpty(payload)) {
                return { ...state };
            }
            const createListError = payload.response;
            const { isLoading, isSuccess, requestFrom } = payload;
            return { ...state, isLoading, createListError, requestFrom, isSuccess };
        }
        case types.DELETE_LIST_ERROR:
        case types.SAVE_TO_LIST_ERROR:
        case types.GET_LIST_ERROR: {
            const payload = action.payload || {};
            if (isEmpty(payload)) {
                return { ...state };
            }
            const error = action.payload.response;
            const { isLoading, isSuccess, requestFrom } = action.payload;
            return { ...state, isLoading, error, requestFrom, isSuccess };
        }
        case types.CLEAR_LIST_ERROR:
            return { ...state, error: {}, createListError: {} };
        case types.SET_SYNC_ERRORS:
            return { ...state, error: action.payload };
        case types.RESET_LIST: {
            const newState = { ...state };
            newState.isSuccess = false;
            newState.error = {};
            newState.requestFrom = null;
            return { ...newState };
        }
        case types.COPY_LIST_SUCCESS_MSG: {
            const showCopyListSuccessMsg = action.payload.show;
            const copyListName = action.payload.name;
            return {
                ...state,
                showCopyListSuccessMsg,
                copyListName,
            };
        }
        case types.ADD_TO_CART_LIST_ITEM_ID: {
            const addToCartListItemId = action.payload;
            return {
                ...state,
                addToCartListItemId,
            };
        }
        default:
            return state;
    }
}

MyListReducer.reducerName = 'MyList';
export default MyListReducer;
